import styled from "styled-components";

import { editableContainer, previewTheme } from "../preview";

/* Mirrors StyledContainerNew on the real patient page (OrderOverview DOBAuth). */
export const StyledPatientPageCard = styled.div`
  background-color: ${previewTheme.surface};
  border: 1px solid ${previewTheme.hairline};
  border-radius: 16px;
  padding: 32px;
  max-width: 588px;

  p {
    color: ${previewTheme.body};
  }

  .title {
    color: ${previewTheme.ink};
  }

  .highlighted {
    color: ${previewTheme.ink};
  }
`;

export const StyledPatientContainer = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid ${previewTheme.indigoBorder};
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  background-color: #f6f8fe;
  margin-bottom: 24px;
`;

/* Non-editable replica of the patient page's date input. */
export const StyledDobPreview = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid ${previewTheme.hairline};
  border-radius: 8px;
  padding: 12px 12px 12px 40px;
  color: ${previewTheme.muted};
  font-size: 14px;
  background-color: ${previewTheme.surface};
  user-select: none;

  i {
    position: absolute;
    left: 12px;
    top: 12px;
    font-size: 18px;
    color: ${previewTheme.muted};
  }
`;

export const StyledVerifyButton = styled.div<{ $invalid?: boolean }>`
  position: relative;
  background-color: ${previewTheme.indigo};
  border: 1px solid
    ${({ $invalid }) => ($invalid ? previewTheme.red : previewTheme.indigo)};
  border-radius: 8px;
  /* Symmetric padding keeps the label centred despite the right-hand badge. */
  padding: 16px 52px;
  cursor: text;

  &:focus-within {
    box-shadow: 0 0 0 3px ${previewTheme.indigoSoft};
  }

  ${editableContainer};
`;

export const StyledFooterNote = styled.p`
  && {
    color: ${previewTheme.muted};
  }
  font-size: 12px;
  text-align: center;
  margin: 0;
`;
